<template>
  <div class="card-single__notifications">
    <Icon icon="fas fa-bell" class="card-single__notifications-icon" />
  </div>
</template>

<script>
// Components
import Icon from 'Ui/AppIcon'

export default {
  name: 'CardSingleNotifications',
  components: {
    Icon,
  },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style scoped>
.card-single__notifications {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -12px;
  right: 7px;
  margin: 0;
  padding: 5px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--c-bright-red-500);
  z-index: 2;
  box-shadow: 0 4px 10px 1px rgba(0, 0, 0, 0.3);
}

.card-single__notifications-icon.app-icon {
  font-size: 14px;
  top: -1px;
  margin: 0;
  color: #fff;
}
</style>
